type Listener<T = any> = (data: T) => void;

class EventBus {
  private listeners: Record<string, Listener[]> = {};

  on<T = any>(event: string, cb: Listener<T>): void {
    (this.listeners[event] = this.listeners[event] || []).push(cb as Listener);
  }

  off<T = any>(event: string, cb: Listener<T>): void {
    this.listeners[event] = (this.listeners[event] || []).filter(fn => fn !== cb);
  }

  emit<T = any>(event: string, data?: T): void {
    (this.listeners[event] || []).forEach(fn => fn(data));
  }
}

const eventBus = new EventBus();
export default eventBus;
